{
  "Open support, new reply": "Support öffnen, neue Antwort",
  "Open support": "Support öffnen",
  "Attachment": "Anhang",
  "Fin · previous AI assistant": "Fin · früherer KI-Assistent",
  "EventLive support team": "Support-Team von EventLive",
  "{name} · EventLive support": "{name} · EventLive-Support",
  "EventLive AI assistant": "KI-Assistent von EventLive",
  "Could not restore your previous conversation. You can retry by reopening the app.": "Dein vorheriges Gespräch konnte nicht wiederhergestellt werden. Öffne die App erneut, um es noch einmal zu versuchen.",
  "Please choose a smaller image.": "Bitte wähle ein kleineres Bild.",
  "Please choose a JPEG or PNG image.": "Bitte wähle ein JPEG- oder PNG-Bild.",
  "Open {name}": "{name} öffnen",
  "We’re here to help": "Wir helfen dir gern",
  "Team review requested · AI can still help": "An das Team weitergeleitet · Die KI hilft weiter",
  "Collapse chat": "Chat einklappen",
  "Expand chat": "Chat ausklappen",
  "Close support": "Support schließen",
  "Current conversation": "Aktuelles Gespräch",
  "Hi! Ask me anything about EventLive: pricing, planning your livestream, or watching an event.": "Hallo! Frag mich alles zu EventLive: Preise, die Planung deines Livestreams oder das Ansehen eines Events.",
  "Have an account? Sign in for help with your events": "Du hast ein Konto? Melde dich an, um Hilfe zu deinen Events zu bekommen",
  "Ask anything about broadcasting, your events or pricing. I can use your account details and the screen you’re on to help.": "Frag alles zum Streamen, zu deinen Events oder zu den Preisen. Um dir zu helfen, kann ich deine Kontodaten und den Bildschirm nutzen, auf dem du gerade bist.",
  "Retry message": "Nachricht erneut senden",
  "Remove photo": "Foto entfernen",
  "Support message": "Nachricht an den Support",
  "Tell us what you’re trying to do…": "Erzähl uns, was du vorhast…",
  "Attach": "Anhängen",
  "Could not open your photos.": "Deine Fotos konnten nicht geöffnet werden.",
  "Send": "Senden",
  "Close support backdrop": "Support schließen (Hintergrund)",
  "AI assistant is typing": "KI-Assistent schreibt",
  "AI assistant": "KI-Assistent",
  "Please sign in to contact support.": "Bitte melde dich an, um den Support zu kontaktieren.",
  "Could not reach support. Check your internet connection and try again.": "Der Support ist nicht erreichbar. Prüfe deine Internetverbindung und versuche es erneut.",
  "Support is temporarily unavailable. Please try again.": "Der Support ist vorübergehend nicht verfügbar. Bitte versuche es erneut.",
  "Could not send your message.": "Deine Nachricht konnte nicht gesendet werden.",
  "No message sent": "Keine Nachricht gesendet",
  "Demo delivery: screenshot included · {platform}": "Demo-Zustellung: mit Screenshot · {platform}",
  "Demo delivery: no screenshot · {platform}": "Demo-Zustellung: ohne Screenshot · {platform}",
  "EventLive · Widget test": "EventLive · Widget-Test",
  "Synthetic account and replies. No customer data or live API calls.": "Fiktives Konto und fiktive Antworten. Keine Kundendaten und keine echten API-Aufrufe.",
  "Your events": "Deine Events",
  "Family celebration": "Familienfeier",
  "Published · Recording ready": "Veröffentlicht · Aufzeichnung bereit",
  "Demo delivery status": "Status der Demo-Zustellung",
  "{brand} support team": "Support-Team von {brand}",
  "You’re chatting with the {brand} support team": "Du chattest mit dem Support-Team von {brand}",
  "You’re talking with the {brand} AI assistant": "Du sprichst mit dem KI-Assistenten von {brand}",
  "The {brand} team is answering here. If you step away, they’ll also reply by email.": "Das Team von {brand} antwortet dir hier. Wenn du weggehst, bekommst du die Antwort auch per E-Mail.",
  "Hi! Ask me anything about YouthStream: plans and pricing, streaming your team’s games, or watching a game.": "Hallo! Frag mich alles zu YouthStream: Pläne und Preise, das Streamen der Spiele deines Teams oder das Ansehen eines Spiels.",
  "Using the app? For help with your account, open Support Chat in YouthStream’s Profile.": "Du nutzt die App? Für Hilfe zu deinem Konto öffne den Support-Chat im Profil von YouthStream."
}
